
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/why-personalia",
      function () {
        return require("private-next-pages/why-personalia.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/why-personalia"])
      });
    }
  